import { render, staticRenderFns } from "./clientbatch.vue?vue&type=template&id=2f2ba41e"
import script from "./clientbatch.vue?vue&type=script&lang=js"
export * from "./clientbatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports